// extracted by mini-css-extract-plugin
export default {"content":"lab-value-delete_content__ALqyp","buttons":"lab-value-delete_buttons__OyOYx","button":"lab-value-delete_button__LJyEl"};